export const aviatorGames = {
  AviatorPG: {
    href: "/casino/pg-aviator",
    code: "",
    casino: "Power Games",
    provider: "Power Games",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/Aviator-PG.webp",
    alt: "Aviator pg",
    name: "Aviator pg",
  },
  AviatorSP: {
    href: "/casino/spribe-aviator",
    code: "",
    casino: "Spribe",
    provider: "Spribe",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/Aviator-Spribe.webp",
    alt: "Aviator spribe",
    name: "Aviator spribe",
  },
  // AviatorQT: {
  //   href: "/casino/qt-aviator",
  //   code: "",
  //   casino: "Qtech",
  //   provider: "WorldCasino",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/aviator-games/Aviator-Qtech.webp",
  //   alt: "Aviator qtech",
  //   name: "Aviator qtech",
  // },
  AviatorAura: {
    href: "/casino/aura-aviator",
    code: "",
    casino: "Aura Gaming",
    provider: "AURA",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/Aviator-Aura.webp",
    alt: "Aviator aura",
    name: "Aviator aura",
  },
  EliteAviatorClubKM: {
    href: "/casino/km-elite-aviator-club",
    code: "",
    casino: "Kingmaker",
    provider: "KINGMAKER",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/EliteAviatorClubKM.webp",
    alt: "Elite Aviator Club km",
    name: "Elite Aviator Club km",
  },
  CosmoRushAviator: {
    href: "/casino/albertcosmo-cosmo-rush",
    code: "",
    casino: "Cosmo - ALBERT",
    provider: "ALBERT_CASINO",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/CosmoRushAviator.webp",
    alt: "cosmo rush aviator",
    name: "cosmo rush aviator",
  },
  // AviatorxMac88: {
  //   href: "/casino/mac88-aviatorx",
  //   code: "",
  //   casino: "Mac88",
  //   provider: "MAC88",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/aviator-games/AviatorxMac88.webp",
  //   alt: "AVIATORX mac88",
  //   name: "AVIATORX mac88",
  // },
  // AviatorX2Mac88: {
  //   href: "/casino/mac88-aviator-x2",
  //   code: "",
  //   casino: "Mac88",
  //   provider: "MAC88",
  //   homeUrl: "http://localhost:3000/Casino",
  //   imgUrl: "./images/aviator-games/AviatorX2Mac88.webp",
  //   alt: "Aviator X2 mac88",
  //   name: "Aviator X2 mac88",
  // },
  
  EliteAviatorClubAltMidas: {
    href: "/casino/aggapkingmidasgaming-elite-aviator-club",
    code: "",
    casino: "Kingmidas Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/EliteAviatorClubAltMidas.webp",
    alt: "Elite Aviator Club kingmidas",
    name: "Elite Aviator Club kingmidas",
  },
  AVIATORXCRASH88: {
    href: "/casino/aggapcrash88gaming-aviatorx",
    code: "",
    casino: "CRASH88 Gaming",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/AVIATORXCRASH88.webp",
    alt: "AVIATORX crash88",
    name: "AVIATORX crash88",
  },
  AviatorXMac88VR: {
    href: "/casino/aggapmac88gamingvirtual-aviator-x",
    code: "",
    casino: "Mac88 Gaming Virtual",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/AviatorXMac88VR.webp",
    alt: "Aviator X mac88 vr",
    name: "Aviator X mac88 vr",
  },
  PushpaRani: {
    href: "/casino/aggapmac88gamingvirtual-pushpa-rani",
    code: "",
    gameType: "crash",
    casino: "Mac88 Gaming Virtual",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/PushpaRani.webp",
    alt: "Pushpa Rani",
    name: "Pushpa Rani",
  },
  AviatorX2Mac88VR: {
    href: "/casino/aggapmac88gamingvirtual-aviatorx2",
    code: "",
    casino: "Mac88 Gaming Virtual",
    provider: "ALT_GAMING_GAP",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/aviator-games/AviatorX2Mac88VR.webp",
    alt: "AviatorX2 mac88 vr",
    name: "AviatorX2 mac88 vr",
  },
};
